module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 考级测试")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "warning"
    }
  }, [_vm._v("\n      1.请根据自己的身份选择不同的考试类型"), _c('br'), _vm._v("\n      2.游客身份可以测试客观题，不可以测试实践题。"), _c('br'), _vm._v("\n      3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。"), _c('br')]), _vm._v(" "), _c('el-steps', {
    staticClass: "elsteps",
    attrs: {
      "space": 200,
      "active": 1,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "报名信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "理论测试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "实践考试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "考级结果"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "查看证书"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [(_vm.row.status == 1) ? _c('div', {
    staticClass: "countdown_class"
  }, [_c('div', {
    staticClass: "countdown_title"
  }, [_vm._v("倒计时")]), _vm._v(" "), _c('van-count-down', {
    ref: "countDown",
    staticClass: "countdown_content",
    attrs: {
      "time": _vm.question.last_time
    },
    on: {
      "change": _vm.onTimeChange,
      "finish": _vm.onTimeFinish
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_left_content"
  }, [_c('div', {
    staticClass: "container_left_content_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.user.face
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.row.user.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("会员号：")]), _vm._v(_vm._s(_vm.row.kaoji.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("总题数：")]), _vm._v(_vm._s(_vm.row.question_list.length) + "道\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container_center",
    class: _vm.targetClass
  }, [_c('div', {
    staticClass: "question_title"
  }, [(_vm.question.option_type == 2) ? _c('el-tag', [_vm._v(_vm._s(_vm.row.current_index + 1) + " 多选")]) : _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.row.current_index + 1) + " 单选")]), _vm._v("\n          " + _vm._s(_vm.question.title) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "question_optoins"
  }, _vm._l((_vm.question.options), function(option, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.onSelect(option)
        }
      }
    }, [_c('el-button', {
      staticStyle: {
        "min-width": "253px !important"
      },
      attrs: {
        "type": option.selected == 1 ? 'primary' : '',
        "round": "",
        "plain": option.selected == 1 ? false : true
      }
    }, [_vm._v(_vm._s(option.title))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "submitBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")])], 1), _vm._v(" "), _c('div', {
    staticClass: "font_resize_class"
  }, [_c('p', {
    staticClass: "font_resize_class_tip"
  }, [_vm._v("字体：")]), _vm._v(" "), _vm._l((_vm.fontSizeArr), function(item, index) {
    return [(item.selected) ? _c('el-button', {
      key: index,
      attrs: {
        "type": "success",
        "circle": ""
      },
      on: {
        "click": function($event) {
          return _vm.fontResizeFun(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('el-button', {
      key: index,
      attrs: {
        "circle": ""
      },
      on: {
        "click": function($event) {
          return _vm.fontResizeFun(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "container_right"
  }, [_c('div', {
    staticClass: "container_right_title"
  }, [_vm._v("答题结果")]), _vm._v(" "), _c('div', {
    staticClass: "container_right_content"
  }, _vm._l((_vm.row.question_list), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('span', {
      class: 'status-' + item.is_right
    }, [_vm._v("\n              " + _vm._s(index + 1) + "\n            ")])])
  }), 0)])])], 1), _vm._v(" "), (_vm.row.score > 90) ? _c('el-dialog', {
    attrs: {
      "title": "完成答题",
      "visible": _vm.dialogVisible,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.row.score) + " "), _c('em', [_vm._v("分")])]), _vm._v(" "), _c('div', [_vm._v("\n      恭喜您以优异成绩通过理论测试，请从三道实践题中，任选一题，点击进入（也可以分别点击查看），\n      内有相关教材的链接、示范视频或文档，请在20天内，通过您的刻苦学习，录制由您亲自表演的30秒以内视频，上传成功后，\n      等候评委在10个工作日内的审核，最终考试结果，将在您的考级申报窗口显示，祝您成功！\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancle
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goApply()
      }
    }
  }, [_vm._v("考试实践考试")])], 1)]) : _c('el-dialog', {
    attrs: {
      "title": "提示信息",
      "visible": _vm.dialogVisible,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.row.score) + " "), _c('em', [_vm._v("分")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("很遗憾您没有通过理论测试")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancle
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onRestart()
      }
    }
  }, [_vm._v("重新开始")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bd0c931","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/kaoji/Exame.vue
// module id = 1229
// module chunks = 0